import { render, staticRenderFns } from "./StyledTextEditor.vue?vue&type=template&id=1165aef2&"
import script from "./StyledTextEditor.vue?vue&type=script&lang=js&"
export * from "./StyledTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./StyledTextEditor.vue?vue&type=style&index=0&id=1165aef2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports